import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import {inject} from "@angular/core";
import {ToastService} from "../services/toast.service";
import {catchError} from "rxjs/operators";
import {throwError} from 'rxjs';
import {UserDataService} from "../services/user-data.service";
import {Router} from "@angular/router";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const userDataService = inject(UserDataService);
  const router = inject(Router);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
        let errorMsg = '';
        if (err.error && err.error.messages) {
          errorMsg = err.error.messages.concat();
          toastService.log(errorMsg);
          return throwError(() => errorMsg);
        }

        if (err.status === 401) {
          userDataService.logout();
          router.navigateByUrl('/auth/login')
        }

        return throwError(() => err);
      }
    )
  );
};
